export const nowIso = () => new Date().toISOString();
export const formatDateTimeVi = (value) => new Intl.DateTimeFormat('vi-VN', {
    dateStyle: 'short',
    timeStyle: 'short'
}).format(new Date(value));
export const formatDateVi = (value) => new Intl.DateTimeFormat('vi-VN', {
    dateStyle: 'medium'
}).format(new Date(value));
export const cn = (...parts) => parts.filter(Boolean).join(' ');
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export function numberFormat(value) {
    return new Intl.NumberFormat('vi-VN').format(value);
}
export function getStatusLabel(status) {
    const map = {
        chinh: 'Chính',
        phu: 'Phụ',
        tam_dung: 'Tạm dừng',
        nhap: 'Nháp',
        da_luu: 'Đã lưu',
        cho_render: 'Chờ render',
        da_render: 'Đã render',
        cho_dang: 'Chờ đăng',
        da_dang: 'Đã đăng',
        da_dung: 'Đã dùng',
        yeu_thich: 'Yêu thích',
        hoan_tat: 'Hoàn tất',
        dang_xu_ly: 'Đang xử lý',
        cho_xu_ly: 'Chờ xử lý',
        loi: 'Lỗi',
        hoan: 'Hoãn'
    };
    return map[status] || status;
}
